export default {
  // global theme for the app
  globalTheme: 'light', // light | dark

  // dark theme colors
  dark: {
    textbase: '#edf0f2',
    background: '#05090c',
    surface: '#111b27',
    primary: '#258d02',
    secondary: '#c8e6c9',
    accent: '#59bbbb',
    error: '#FF5252',
    info: '#2196F3',
    success: '#258d02',
    warning: '#FFC107'
  },

  // light theme colors
  light: {
    //textbase: '#222222',
    textbase: '#228B22',
    background: '#ffffff',
    surface: '#f2f5f8',
    primary: '#258d02',
    secondary: '#c8e6c9',
    accent: '#59bbbb',
    error: '#ef476f',
    info: '#2196F3',
    success: '#258d02',
    warning: '#ffd166'
  }
}
